import React from "react";
import { DragDropListTemplate } from "themes/common/components";

function DragDropList(props) {
    return <DragDropListTemplate {...props} />;
}

export default DragDropList;
